import { AnnuityProviderResponse } from "./annuityProviderResponse";
import { MessageResponse } from "./messageResponse";

export class AnnuityProvidersResponse extends MessageResponse {
    providers: Array<AnnuityProviderResponse>
}
